import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
import { colors, greys } from "../../../styles/color.styles";

const sliderRoot: CSSProperties = {
  position: "relative",
  height: 13,
  width: "100%",
  userSelect: "none",
  marginTop: 20,
};

const trackRoot: CSSProperties = {
  position: "absolute",
  width: "100%",
  height: "100%",
  cursor: "pointer",
  padding: "4px 0",

  "& .relative-track-root": {
    position: "relative",
    width: "100%",
    height: 5,
    borderRadius: 2,
    overflow: "hidden",
  },

  "& .track": {
    position: "absolute",
    left: 0,
    right: 0,
    height: 5,
    background: greys.cloudyBlue,

    "&.active": {
      background: colors.green.darker,
    },

    "&.error": {
      background: colors.peach.darker,
    },
  },
};

const thumb: CSSProperties = {
  cursor: "pointer",
  position: "absolute",
  transform: "translate(-50%, calc(-50% + 6.5px))",
  borderRadius: "50%",
  width: 20,
  height: 20,
  background: greys.white,
  border: `1px solid ${greys.blueGrey}`,
};

const constraintMark: CSSProperties = {
  backgroundColor: colors.blueDusk.lighter,
  width: 7,
  height: 7,
  borderRadius: "50%",
  position: "absolute",
  transform: "translate(-50%, calc(-50% - 2.5px))",
};

const noonMark: CSSProperties = {
  backgroundColor: colors.yellow.lighter,
  width: 7,
  height: 7,
  borderRadius: "50%",
  position: "absolute",
  transform: "translate(-50%, calc(-50% - 2.5px))",

  "& .label": {
    position: "absolute",
    bottom: "100%",
    color: colors.yellow.darker,
    fontSize: "11px",
    transform: "translateX(calc(-50% + 3.5px))",
    whiteSpace: "nowrap",
    paddingBottom: 4,
  },
};

const displayInformation: CSSProperties = {
  paddingTop: 14,
  "& .summary": {
    color: greys.standard,
    fontSize: "14px",
  },
  "& .range": {
    display: "flex",
    alignItems: "center",
    color: greys.slate,
    fontSize: "12px",
    lineHeight: "24px",
    paddingTop: 2,

    "& .info-icon": {
      marginLeft: 5,
      fontSize: "14px",
      color: greys.blueGrey,
    },
  },
  "& .outside-hours": {
    display: "flex",
    alignItems: "center",
    color: colors.peach.standard,
    fontSize: "12px",
    wordBreak: "break-word",

    "& .error-icon": {
      fontSize: "14px",
      marginRight: 5,
    },
  },
};

const noIntersection: CSSProperties = {
  paddingTop: 24,
  fontSize: 13,

  "& .warning": {
    color: colors.peach.darker,
    display: "flex",
    flexDirection: "row",
    lineHeight: 1.2,

    "& .icon": {
      width: 14,
      height: 14,
    },
    "& .text": {
      paddingLeft: 8,
    },
  },
  "& .contact": {
    color: greys.slate,
    paddingLeft: 22,
    paddingTop: 8,

    "& a": {
      color: greys.slate,
      textDecoration: "underline",
    },
  },
};

const muted: CSSProperties = {
  opacity: 0.5,
  pointerEvents: "none",
};

export const styles = {
  sliderRoot,
  trackRoot,
  thumb,
  constraintMark,
  noonMark,
  displayInformation,
  noIntersection,
  muted,
};
